import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
} from "@angular/core";

import { TreeNode } from "primeng/api";
import { TreeTable } from "primeng/treetable";
import { IdName } from "../domain/idname";
import * as _ from "lodash";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from 'rxjs';
import { ReportDefinitionLine } from "../domain/reportdefinitionline";
import { LineService } from "../service/line.service";

export const sharedSubject = new Subject<void>();

@Component({
    selector: "tree-table",
    templateUrl: "./tree-table.component.html",
})



export class TreeTableComponent implements OnInit {

    constructor(private router: Router, private route: ActivatedRoute, private lineService: LineService) {
        this.items = [
            {
                label: "Collapse All",
                icon: "ui-expand-less",
                command: () => this.collapseAllNodes(),
            },
            {
                label: "Expand All",
                icon: "ui-expand-more",
                command: () => this.expandAllNodes(),
            },
        ];
    }

    @Input() set inputTreeNodes(value: TreeNode[]) {
        this.treeNodes = this.processNodes(value);

        this.treeNodesForTable = this.treeNodes;

        // if (!this.toggleLeavesOnly) {
        //     this.processLeaves();
        // }

        this.processLeaves();

        this.changeToggleLeavesOnly();
    }
    @Input() treeColumns: any[];
    @Input() disableHierarchyButton: boolean = false;
    @Input() showLeafViewByDefault: boolean = false;

    @ViewChild("tree", { static: false }) tree: TreeTable;

    @Input() loadingTreeNodes = true;
    searchValue: string = null;
    leaves: TreeNode[];
    toggleLeavesOnly: boolean = false;

    treeNodesForTable: TreeNode[];
    leafNodesForTable: TreeNode[];

    treeNodes: TreeNode[];
    showHideShowHierarchyButton: boolean;

    ngOnInit() {
        if (this.showLeafViewByDefault) {
            this.toggleLeavesOnly = true;
        }
    }

    changeToggleLeavesOnly() {
        this.loadingTreeNodes = true;
        if (this.toggleLeavesOnly) {
            this.treeNodes = this.leafNodesForTable;
        } else {
            this.treeNodes = this.treeNodesForTable;
            this.collapseAllNodes();
        }
        this.loadingTreeNodes = false;
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children != null) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    collapseAllNodes() {
        if (this.treeNodes) {
            this.treeNodes.forEach((node) => {
                this.expandRecursive(node, false);
            });
            this.treeNodes = [...this.treeNodes];
        }
    }

    expandAllNodes() {
        this.treeNodes.forEach((node) => {
            this.expandRecursive(node, true);
        });
        this.treeNodes = [...this.treeNodes];
    }

    leavesRecursive(node: TreeNode) {
        if (node.leaf) {
            node.data.leaf = true;
            this.leaves.push(node);
        }
        if (node.children) {
            node.children.forEach((childNode) => {
                this.leavesRecursive(childNode);
            });
        }
        node.children = null;
    }

    processLeaves() {
        this.leaves = [];
        if (this.treeNodes && this.treeNodes.length > 0) {
            var arrayOfNodes = _.cloneDeep(this.treeNodes);
            arrayOfNodes.forEach((node: TreeNode) => {
                this.leavesRecursive(node);
            });
            this.leafNodesForTable = this.leaves;
        }
    }

    clearSelection() {
        this.selected = null;
    }

    processNodes(treeStructure: TreeNode[]) {
        if (treeStructure) {
            var nodesHaveChildren = false;
            treeStructure.forEach(node => {
                this.processNodesRecursive(node);
                if (node.children) {
                    nodesHaveChildren = true;
                }
            });

            this.showHideShowHierarchyButton = nodesHaveChildren;
        }

        return treeStructure;
    }

    processNodesRecursive(node: TreeNode) {
        if (node.leaf) {
            //color all leaves
            node.data.leaf = true;
        }
        if (node.children) {
            node.children.forEach(childNode => {
                this.processNodesRecursive(childNode);
            });
        }

        //handle too much line numbers
        /*if ((node.data.lineNumbers.match(/,/g) || []).length > 5) {
            node.data.lineNumbersExtended = node.data.lineNumbers.replace(/((?:[^,]*,){5}[^,]*),/g, '$1<br\/>');
            node.data.lineNumbers = node.data.lineNumbers.split(",").splice(0, 5) + "...";
        }*/
    }










    @Input() range: boolean;
    @Input() removeLoader: boolean;


    @Input() filter: IdName[];

    @Input() selectionMode: string = "none";
    @Input() selected: TreeNode[];
    @Output() unselectedNode = new EventEmitter<TreeNode>();

    @Output() selectedChange = new EventEmitter<TreeNode[]>();
    @Output() onSearchEnter = new EventEmitter<TreeNode[]>();
    @Output() closeModalEvent = new EventEmitter<void>();
    @Output() displayLineEvent = new EventEmitter<ReportDefinitionLine>();

    transferOnEnter() {
        //if hierarchy is one, nothing should be transferred on enter
        if (this.toggleLeavesOnly && Array.isArray(this.tree.filteredNodes) && this.tree.filteredNodes.length > 0) {
            this.onSearchEnter.emit(this.tree.filteredNodes);
            this.searchValue = null;
            this.tree.filterGlobal("", "contains");
        }
    }

    didVote = false;

    totalAccountsNumber: number;
    fullAccountsData: TreeNode[];

    items: any[];

    selectNode() {
        this.selectedChange.emit(this.selected);
    }

    unselectNode() {
        this.selectedChange.emit(this.selected);
    }

    goToReportLine(id: string): void {
        console.log("id", id);


        var rptid = window.location.href.split("/").pop();
        this.lineService.getByReportIdEndRowNo(Number(rptid), id.replace("#", "").toString())
            .then(line => {
                sessionStorage.setItem('rptLine', JSON.stringify(line));
                sharedSubject.next();
                this.router.navigate(['/reportdefinitions', rptid]);
                this.displayLineEvent.emit(line);
            })

    }
    saveReportDefinitionLine(reportDefinitionLine: ReportDefinitionLine) {

    }
}
